/*
 * Fullscreen Loading Overlay (FLO)™
 */

import React from "react";

const Loader: React.FC = function Loader() {
  return (
    <div className="loading">
      <span className="loading-overlay">
        <span className="loading-overlay-inner">
          <span className="k-loading-mask">
            <span className="k-loading-text">Loading...</span>
            <span className="k-loading-image" />
            <span className="k-loading-color" />
          </span>
        </span>
      </span>
    </div>
  );
};

export default Loader;
